import { Fragment } from 'react'

import formatStat, { nearbyProfileStatKeyFormat, nearbyProfileStatKeyOrder } from '@utils/formatStat'
import { useAuthContext } from '@contexts/authContext'
import { fontSize, size } from '@styles/theme'
import capitalize from '@utils/capitalize'
import styled from '@emotion/styled'

const Container = styled.div`
  padding-left: ${size(3)};
`

const StatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100dvw - ${size(6)});
`

const StatHR = styled.div`
  flex-grow: 1;
  border-bottom: 0.5px solid rgba(255,255,255, 0.2);

  &:first-of-type {
    border-bottom: none;
  }
`

const StatListItem = styled.div`
  padding: ${size(1.85)} 0;
  display: flex;
  gap: ${size(2)};
`

const StatKey = styled.b`
  display: flex;
  flex-shrink: 0;
  width: 40%;
  line-height: ${size(2.25)};
  font-size: ${fontSize('sm')};
  font-weight: 500;
`
  
const StatData = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${size(1)};

  width: 60%;

  font-size: ${fontSize('sm')};
  font-weight: 500;
  word-spacing: -2px;
  color: rgba(255,255,255,0.8);
`

const ProfileStats = ({ user }) => {
  const { state: authState } = useAuthContext()
  const extended = user?.extendedInfos || {}

  const renderStat = (stat) => {
    let formattedStat = formatStat(stat, extended[stat], { currentUser: authState?.user || {} })
    if (typeof formattedStat === 'string') {
      formattedStat = capitalize(formattedStat)
    } else if (stat instanceof Array) {
      stat.map(val => typeof val === 'string' ? capitalize(val) : val)
    }
    return formattedStat
  }

  const renderStatListItem = (statType, renderedStat) => (
    <>
      <StatHR/>
      <StatListItem>
        <StatKey>{capitalize(nearbyProfileStatKeyFormat[statType] || statType)}</StatKey>
        <StatData>{renderedStat}</StatData>
      </StatListItem>
    </>
  )

  const renderStatList = () => {
    const statList = nearbyProfileStatKeyOrder.map((key, i) => {
      const renderedStat = renderStat(key)
      if ((Array.isArray(renderedStat) && renderedStat.length === 0)) return;
      if (!renderedStat) return;
      return <Fragment key={i}>{renderStatListItem(key, renderedStat)}</Fragment>
    })
    return statList.filter((item) => item !== undefined)
  }

  const statList = renderStatList()
  if (statList.length > 0)
  return (
    <Container>
      <StatsContainer>
        {statList}
      </StatsContainer>
    </Container>
  )
}

export default ProfileStats
